import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import Caption from 'LuxKit/Typography/Caption'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import AccommodationRoomQuantitySelect from 'components/AccommodationKit/AccommodationPackageSelection/AccommodationRoomQuantitySelect'
import type { AccommodationRoomQuantityOption } from 'components/AccommodationKit/AccommodationPackageSelection/AccommodationRoomQuantityOptions'

const OptionDQuantity = styled.div`
  display: grid;
  align-content: start;
  gap: ${rem(4)};
`

interface FlashPackageRoomQuantityProps {
  value: number
  disabled: boolean
  options: Array<AccommodationRoomQuantityOption>
  quoteKey?: string
  label: string
  onChange: (quantity: number) => void
  initialActionLabel?: string
  /** Multi-room cards hide the heading below this size until a room is selected. */
  constrainHeading?: boolean
  headingMin?: App.ScreenSize
}

function FlashPackageRoomQuantity({
  value,
  disabled,
  options,
  quoteKey,
  label,
  onChange,
  initialActionLabel,
  constrainHeading = false,
  headingMin,
}: FlashPackageRoomQuantityProps) {
  const intl = useIntl()
  const heading = <Caption variant="medium" weight="bold">
    {intl.formatMessage({
      id: 'q-d3wuJ-MwAHKFNfnfaL',
      defaultMessage: 'Rooms',
      description: 'Quantity heading above the Flash package room selection control',
    })}
  </Caption>

  return <OptionDQuantity>
    {constrainHeading && <CSSBreakpoint min={headingMin}>{heading}</CSSBreakpoint>}
    {!constrainHeading && heading}
    <AccommodationRoomQuantitySelect
      value={value}
      disabled={disabled}
      options={options}
      quoteKey={quoteKey}
      label={label}
      onChange={onChange}
      initialActionLabel={initialActionLabel}
    />
  </OptionDQuantity>
}

export default FlashPackageRoomQuantity
